import React from 'react'
import { CNavGroup, CNavItem } from '@coreui/react'

import _modules from '../../_modules'
import meetings from '../../collectionsStructure/mm-meetings'
import meeting_minutes from '../../collectionsStructure/mm-meeting_minutes'

const pm_items = {
  component: CNavGroup,
  name: 'Meeting Management',
  icon: <i className="material-icons-outlined">meeting_room</i>,
  items: [],
}
let output = []

if (_modules.meeting || _modules.meeting_minute) {
  // add more items above with OR condition
  if (_modules.meeting)
    pm_items.items.push({
      component: CNavItem,
      name: 'Meetings',
      to: '/meeting',
      permissionSource: meetings.permissionSource,
      icon: <i className="material-icons-outlined">meeting_room</i>,
    })
  if (_modules.meeting_minute)
    pm_items.items.push({
      component: CNavItem,
      name: 'Meetings Minutes',
      to: '/meeting-minute',
      permissionSource: meeting_minutes.permissionSource,
      icon: <i className="material-icons-sharp">subject</i>,
    })

  output.push(pm_items)
}

export default output
